import { api } from 'app/config/apiConfig';
import { AuthResponse, getMeApi, userActions } from 'entities/User';
import i18n from 'app/config/i18Config/i18n';
import { showNotification } from 'app/providers/NotificationsProvider';

export const yandexAuthApi = api.injectEndpoints({
  endpoints: (build) => ({
    yandexAuth: build.mutation<AuthResponse, string>({
      query: (token) => ({
        url: '/authorization/yandex-login',
        method: 'POST',
        body: { token },
      }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        try {
          const yandexAuthResponse = await queryFulfilled;

          dispatch(userActions.setCredentials({ credentials: yandexAuthResponse.data, remember: true }));

          const getMeResponse = await dispatch(getMeApi.endpoints.getMe.initiate()).unwrap();

          dispatch(userActions.setUserData(getMeResponse));
        } catch (error) {
          showNotification('error', i18n.t('Error', { ns: 'common' }), i18n.t('Error when authorization via Yandex', { ns: 'common' }));
        }
      },
    }),
  }),
});

export const { useYandexAuthMutation } = yandexAuthApi;
